// src/utils/genderIcons.js
import React from 'react';
import { FaMars, FaVenus } from 'react-icons/fa';

/**
 * Renderiza el ícono correspondiente según el género.
 * @param {string} sexo - Puede ser "macho" o "hembra".
 * @returns {JSX.Element|null} El icono de género o null si no se reconoce.
 */
export const renderGenderIcon = (sexo) => {
  if (!sexo) return null;
  const s = sexo.trim().toLowerCase();
  if (s === 'macho')
    return <FaMars style={{ color: '#0093F5', fontSize: '1.5rem' }} />;
  if (s === 'hembra')
    return <FaVenus style={{ color: '#FF69B4', fontSize: '1.5rem' }} />;
  return null;
};
